module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card coach-card"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image",
    style: ({
      backgroundColor: _vm.coach.background_color
    })
  }, [_c('image-composite', {
    attrs: {
      "background": _vm.background,
      "foreground": _vm.foreground
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.coach.languages[0].pivot.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('small', [_c('b', [_vm._v(_vm._s(_vm.coachState))]), _vm._v(" " + _vm._s(_vm.coach.updated_at))])])]), _vm._v(" "), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.editCoach
    }
  }, [_vm._v("Editar")]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.openDeleteModal
    }
  }, [_vm._v(_vm._s(_vm.deleteText))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00353f0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coach/CoachCard.vue
// module id = 300
// module chunks = 1